import React, { useState } from 'react';
import { MethodEnum } from 'axios/type';
import useAxios from 'axios/useAxios';
import ReactSelect from 'components/ReactSelect';
import Button from 'tradevan-ui/Button';
import {
  EnumDownloadType,
  EnumFlatStyle,
  EnumRetailerSetup,
  EnumMasterSort,
} from 'view/Layout/enum';
import { EnumDetail, EnumMaster } from '../../../../init';
import { DownloadProps, IexportReceiveRequest } from './type';
import { getRevQueryDownloadOption } from './consts';

const DownloadPdf = (props: DownloadProps) => {
  const {
    pdfPreview,
    formReturnDetail,
    handleSearch,
    retailerSetup,
    pdfDownload,
  } = props;
  const axios = useAxios();

  const { watch, control, handleSubmit } = formReturnDetail;

  const master = watch('master');
  const detail = watch('detail');
  const pageObj = watch('pageObj');
  const masterSort = watch('masterSort');
  const options = getRevQueryDownloadOption(
    retailerSetup[EnumRetailerSetup.exportItemList],
  );
  const optionMaxLength = options.reduce((a, b) => {
    return a.label.length > b.label.length ? a : b;
  });
  /** 下載檔案的種類 */
  const [downloadType, setDownloadType] = useState(options[0].value || '');

  // #region 檔案下載相關Function

  /** 下載TXT */
  const downloadTxt = async (flatStyle: EnumFlatStyle) => {
    const response = await axios.blobAxios<IexportReceiveRequest>(
      MethodEnum.post,
      'receive/exportReceive',
      {
        flatStyle,
        retailerId: master[EnumMaster.retailerId],
        receiveSeqNos: detail
          .filter((v) => v.selected)
          .map((v) => v[EnumDetail.orderNoCnt]),
        sort: masterSort
          .filter((v) => v[EnumMasterSort.property] !== '')
          .map((v) => ({
            ...v,
            [EnumMasterSort.desc]: v.desc ? 'Y' : 'N',
          })),
      },
    );

    axios.blobDownload(response);
    handleSubmit(handleSearch(pageObj.pageNo, pageObj.pageSize))();
  };

  /** 下載檔案判斷 */
  const handleReportDownload = () => {
    switch (downloadType) {
      case EnumDownloadType.報表下載:
        pdfDownload();
        break;
      case EnumDownloadType.批次預覽:
        pdfPreview();
        break;
      case EnumDownloadType.文字檔下載:
        downloadTxt(EnumFlatStyle.文字檔下載TXT);
        break;
      case EnumDownloadType.貨號文字檔下載:
        downloadTxt(EnumFlatStyle.貨號文字檔CSV);
        break;

      default:
        break;
    }
  };
  // #endregion

  return (
    <div className="btn-item float-right">
      <div
        className="form-group d-inline-block"
        style={{
          fontSize: '1rem',
          minWidth: `${optionMaxLength.label.length + 1.5}rem`,
        }}
      >
        <ReactSelect
          styles={{
            option: (obj) => ({
              ...obj,
            }),
          }}
          control={control}
          name=""
          value={downloadType}
          isDisabled={!detail.filter((v) => v.selected).length}
          watchValue={() => {}}
          onChange={(e) => {
            setDownloadType(e as EnumDownloadType);
          }}
          options={options}
        />
      </div>
      <Button
        rounded
        style={{ marginLeft: '0.25rem' }}
        disabled={!detail.filter((v) => v.selected).length}
        onClick={handleReportDownload}
      >
        確定
      </Button>
    </div>
  );
};

export default DownloadPdf;
